import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API, withCredentials: true });

// Silently renew an expired access token (60-min lifetime) using the refresh
// cookie, then retry the original request once. Prevents surprise
// "Not authenticated" errors during long admin sessions (e.g. editing a product).
let refreshPromise = null;
function doRefresh() {
  if (!refreshPromise) {
    refreshPromise = api.post("/auth/refresh").finally(() => { refreshPromise = null; });
  }
  return refreshPromise;
}
api.interceptors.response.use(
  (r) => r,
  async (error) => {
    const { response, config } = error;
    const url = (config && config.url) || "";
    const isAuthRoute = url.includes("/auth/refresh") || url.includes("/auth/login") || url.includes("/auth/register");
    if (!response || response.status !== 401 || !config || config._retried || isAuthRoute) {
      return Promise.reject(error);
    }
    config._retried = true;
    try {
      await doRefresh();
      return api(config);
    } catch (e) {
      return Promise.reject(error);
    }
  }
);

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export function formatPrice(value, currency = "AUD") {
  if (value == null) return "";
  return new Intl.NumberFormat("en-AU", { style: "currency", currency, maximumFractionDigits: 0 }).format(value);
}

export function mediaUrl(path) {
  if (!path) return "";
  if (path.startsWith("http")) return path;
  return `${BACKEND_URL}${path}`;
}

export function track(event, data = {}) {
  api.post("/analytics/event", { event, data }).catch(() => {});
}

export default api;
